import { Suspense, useEffect } from "react";
import dynamic from "next/dynamic";
import { Box } from "@mui/material";

import { observer, useStore } from "../../../service/mobx";

const PaperCard = dynamic(() =>
  import("../../Card/Paper").then(module => module.PaperCardSize5)
);
const TaskCard = dynamic(() =>
  import("../../Card/Task").then(module => module.CardTaskSize3)
);
const VideoCard = dynamic(() =>
  import("../../Card/External/Video").then(module => module.CardVideoSize2)
);
const ModelCard = dynamic(() =>
  import("../../Card/Model").then(module => module.ModelCardSize5)
);

function SuggestionPane() {
  const { device, search } = useStore();
  const cards = {
    paper: PaperCard,
    tag: TaskCard,
    video: VideoCard,
    model: ModelCard
  };
  const entityName = search.suggestedEntityInFocus?.__typename?.toLowerCase();
  const Card = cards[entityName] ?? (() => {});
  const props = { [entityName]: search.suggestedEntityInFocus };

  useEffect(() => search.set.suggestedEntityInFocus, [search]);

  return search.suggestedEntityInFocus && device.isPhone === false ? (
    <Box p={2} display="flex" justifyContent="center">
      <Suspense>
        <Card tone="var(--surface-container-lowest)" {...props} />
      </Suspense>
    </Box>
  ) : null;
}

export default observer(SuggestionPane);
